import type { BGConfig } from "Data/BGConfig";
import { GameConfig } from "Data/GameConfig";
import { makeSprite } from "html-living-framework/lib/Utils/PixiUtils";
import type { ILevelState } from "Interfaces/ILevelState";

export class InteriorBackground extends PIXI.Container {
// #region children
    protected bgs: PIXI.Sprite[] = [];
// #endregion

    public init(pSize: PIXI.Point, pData: ILevelState) {
        const id = pData.id;
        const {interior: config} = GameConfig.locations[id];

        this.addBackground(config.bg, pData);

        return this;
    }

    public animateIn() {
        //
    }

    public onResize(pSize: PIXI.Point) {
        //
    }

    public destroy(pOptions?: PIXI.DestroyOptions | boolean) {
        super.destroy(pOptions);
    }

    private addBackground(pBG: BGConfig, state: ILevelState) {
        if (Array.isArray(pBG)) {
            for (const _bg of pBG) {
                const newsprite = makeSprite(state.id + "/" + _bg.filename);
                newsprite.position.set(_bg.x, _bg.y);
                this.bgs.push(this.addChild(newsprite));
            }
        }
        else {
            const newsprite = makeSprite(state.id + "/" + pBG.filename);
            this.bgs.push(this.addChild(newsprite));
        }
    }

}
